import React from 'react';
import SelectStepTemplate from '../../../template/SelectStepTemplate';
import useGetMateriais, {
  buildOutrosTecidos,
} from '../../../template/UseGetMateriais';
import TipoDivergenciasInfoKey from '../../../TipoDivergenciasInfoKey.';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import UploadQuantidadeTecidoTrianguladoStep from '../../upload-step/UploadQuantidadeTecidoTrianguladoStep';

const QuantidadeTecidoTrianguladoDiferenteNotaFiscal: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { loading, materiais } = useGetMateriais(
    TipoDivergenciasInfoKey.TECIDO
  );
  const newMateriais = [...materiais, buildOutrosTecidos()];

  const stepNumber = '2';
  const stepSubTitle = 'Selecione o tecido triangulado com divergência na quantidade.';
  const stepTitle = 'Qual tecido triangulado está com quantidade divergente da nota fiscal?';
  
  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={UploadQuantidadeTecidoTrianguladoStep as TipoDivergenciaComponent}
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey='tecidos'
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};

export default QuantidadeTecidoTrianguladoDiferenteNotaFiscal;
